import { AIONZ_DIALOG_DATA, AionzDialogModule, AionzDialogRef, HeaderBottomSheetComponent } from '@aionzdev/design-system';
import { PurchaseRequestOptionDialogData } from '../../../interfaces/purchase-request-option-dialog-data';
import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  PurchaseRequestOptionDialogAction,
  PurchaseRequestOptionDialogResult
} from '../../../interfaces/purchase-request-option-dialog-result';

interface PurchaseRequestOptionCard {
  action: PurchaseRequestOptionDialogAction;
  title: string;
  description: string;
  icon: string;
  iconLabel: string;
}

@Component({
  selector: 'aionz-purchase-request-option-dialog',
  imports: [AionzDialogModule, MatIconModule, HeaderBottomSheetComponent],
  templateUrl: './purchase-request-option-dialog.component.html',
  styleUrl: './purchase-request-option-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PurchaseRequestOptionDialogComponent {
  protected readonly optionAction = PurchaseRequestOptionDialogAction;

  public readonly onDownloadOrder = output<void>();

  private readonly dialogRef = inject(
    AionzDialogRef<
      PurchaseRequestOptionDialogComponent,
      PurchaseRequestOptionDialogResult | undefined
    >
  );
  private readonly data = inject<PurchaseRequestOptionDialogData | null>(AIONZ_DIALOG_DATA, { optional: true });
  protected readonly title = this.data?.title ?? 'Selecione uma opção';
  protected readonly subtitle = this.data?.subtitle;

  protected readonly options: PurchaseRequestOptionCard[] = [
    {
      action: PurchaseRequestOptionDialogAction.DOWNLOAD_ORDER,
      title: 'Baixar pedido',
      description: 'Faça o download dos produtos para preencher manualmente.',
      icon: 'download',
      iconLabel: 'Baixar pedido'
    },
    {
      action: PurchaseRequestOptionDialogAction.UPLOAD_SPREADSHEET,
      title: 'Fazer upload da planilha',
      description:
        'Faça o upload do seu pedido preenchido no formato Excel juntamente com o pdf do orçamento do Fornecedor',
      icon: 'upload',
      iconLabel: 'Fazer upload da planilha'
    }
  ];

  protected close(): void {
    this.dialogRef.close();
  }

  protected selectOption(action: PurchaseRequestOptionDialogAction): void {
    if (action === PurchaseRequestOptionDialogAction.DOWNLOAD_ORDER) {
      this.onDownloadOrder.emit();
      return;
    }

    this.dialogRef.close({ action });
  }
}
